import { useHistory } from "react-router-dom";
import { PS_URLS, useCompanyId } from "../../core";
import { ICP4OnboardingWorkflowContainer } from "./ICP4OnboardingWorkflowContainer";
import { ICP4ProjectSyncing } from "./ICP4ProjectSyncing";

export function ICP4ProjectsConfiguration({renderHeader = true}: {renderHeader?: boolean}) {
  const companyId = useCompanyId();
  const history = useHistory();

  return (
    <ICP4OnboardingWorkflowContainer 
      heading="Select & Configure Sites" 
      subHeading="Select the sites you want to sync data from."
      backButtonProps={{
        onClick: () => {
          history.push(`${PS_URLS(companyId).icp4VendorsIntegration()}`);
        }
      }}
      nextButtonProps={{
        onClick: () => {
          history.push(`${PS_URLS(companyId).icp4InterestRegistered()}`);
        }
      }}
    >
      <ICP4ProjectSyncing renderHeader={false} />
    </ICP4OnboardingWorkflowContainer>
  );
}